export const LOGIN_REQUESTED = 'LOGIN_REQUESTED';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';

export const SEND_VERIFICATION_CODE_REQUESTED = 'SEND_VERIFICATION_CODE_REQUESTED';
export const SEND_VERIFICATION_CODE_SUCCESS = 'SEND_VERIFICATION_CODE_SUCCESS';
export const SEND_VERIFICATION_CODE_FAILED = 'SEND_VERIFICATION_CODE_FAILED';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_REQUESTED = 'LOGOUT_REQUESTED';

export const PROFILE_REQUESTED = 'PROFILE_REQUESTED';
export const PROFILE_SUCCESS = 'PROFILE_SUCCESS';
export const PROFILE_FAILED = 'PROFILE_FAILED';

export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';

export const SPOT_LIST_REQUESTED = 'SPOT_LIST_REQUESTED';
export const SPOT_LIST_SUCCESS = 'SPOT_LIST_SUCCESS';
export const SPOT_LIST_FAILED = 'SPOT_LIST_FAILED';

export const REPORTS_REQUESTED = 'REPORTS_REQUESTED';
export const REPORTS_SUCCESS = 'REPORTS_SUCCESS';
export const REPORTS_FAILED = 'REPORTS_FAILED';

export const UPDATE_REPORTS_REQUESTED = 'UPDATE_REPORTS_REQUESTED';
export const UPDATE_REPORTS_SUCCESS = 'UPDATE_REPORTS_SUCCESS';
export const UPDATE_REPORTS_FAILED = 'UPDATE_REPORTS_FAILED';

export const PROMO_CODE_REPORTS_REQUESTED = 'PROMO_CODE_REPORTS_REQUESTED';
export const PROMO_CODE_REPORTS_SUCCESS = 'PROMO_CODE_REPORTS_SUCCESS';
export const PROMO_CODE_REPORTS_FAILED = 'PROMO_CODE_REPORTS_FAILED';

export const SPOT_MULTIDAY_PRICING_REQUESTED = 'SPOT_MULTIDAY_PRICING_REQUESTED';
export const SPOT_MULTIDAY_PRICING_SUCCESS = 'SPOT_MULTIDAY_PRICING_SUCCESS';
export const SPOT_MULTIDAY_PRICING_FAILED = 'SPOT_MULTIDAY_PRICING_FAILED';

export const UPDATE_IS_DEMO_MODE = 'UPDATE_IS_DEMO_MODE';
